namespace SolovisGateway.Admin.Authentication {
    export class JwtAuthAppModel {
        name: string;
        code: string;
        sharedSigningKey: string;
        jwtPostUrl: string;
        isAdvertised: boolean;
        isRestricted: boolean;
        useAutoLogin: boolean;

        get canHaveUsers(): boolean {
            return this.isRestricted;
        }

        constructor(data: any) {
            if (data) {
                this.name = data.name;
                this.code = data.code;
                this.isAdvertised = data.isAdvertised;
                this.isRestricted = data.isRestricted;
                this.useAutoLogin = data.useAutoLogin;
                this.sharedSigningKey = data.sharedSigningKey;
                this.jwtPostUrl = data.jwtPostUrl;
            }
        }

        static initializeData(data: any) {
            data.isAdvertised = false;
            data.isRestricted = true;
            data.useAutoLogin = false;
        }

        toDeleteParams(): { code: string } {
            return {
                code: this.code
            };
        }

        toGetUsersParams(): { jwtAuthAppCode: string } {
            return {
                jwtAuthAppCode: this.code
            };
        }

        toAddParams(): {
            name: string, code: string, sharedSigningKey: string, jwtPostUrl: string,
            isAdvertised: boolean, isRestricted: boolean, useAutoLogin: boolean
        } {
            return {
                name: this.name,
                code: this.code,
                jwtPostUrl: this.jwtPostUrl,
                sharedSigningKey: this.sharedSigningKey,
                isAdvertised: this.isAdvertised,
                isRestricted: this.isRestricted,
                useAutoLogin: this.useAutoLogin
            };
        }

        clearSensitiveData() {
            this.sharedSigningKey = null;
            this.jwtPostUrl = null;
        }
    }
}